/*
  assets/nibec-cotizacion-formal.js · Bigbuda T-0449 (14-oct-2026)
  Cotización formal en 2 pasos del formulario de /pages/contacto (sections/nibec-contacto-form.liquid,
  ajuste «Cotización formal en 2 pasos»). Pedido de Fernando y Benjamín: volver al formulario con los
  datos necesarios para generar la cotización en Bsale.

  Qué hace:
    · Paso 1 (nombre, correo, teléfono, producto y cantidad) y paso 2 (RUT, razón social, comuna y dirección
      de despacho) son bloques del MISMO formulario: un solo envío nativo de Shopify, el mismo correo a atención
      al cliente y el mismo mensaje de éxito (data-brevo-exito → GA4 generate_lead). Este archivo solo muestra de
      a un bloque, valida y, al enviar, ordena el RUT y arma la copia de dirección para Brevo.
    · «Continuar» valida el paso 1 y pasa al 2; «Volver» regresa sin perder lo escrito. Enter en el paso 1 hace lo
      mismo que «Continuar».
    · RUT con formato chileno: acepta 12345678-5, 12.345.678-5 o 123456785 (con K), comprueba el dígito
      verificador (módulo 11) y lo deja escrito como 12.345.678-5.
    · Captcha: el envío de Shopify pasa por hCaptcha; la validación de aquí corre antes (captura en window) y, si bloquea,
      corta el evento entero para que el captcha no arranque.
    · Brevo: nibec-brevo.js lee cada campo por su data-brevo. Aquí solo se usan claves que el Worker ya entiende
      (rut y direccion = «dirección, comuna»). La razón social y la comuna sueltas llegan al correo, no a Brevo.
    · Medición: el botón de envío sigue siendo hijo directo del formulario (form#contact_form > button, el selector
      del evento «Enviar formulario» de Heatmap); los pasos publican nibec_cotizacion_paso (dataLayer y
      Shopify.analytics) y los botones nuevos llevan data-hm-id.

  Ajuste «Campos Giro y Empresa/Persona» (17-oct-2026, propuesta para Benjamín; apagado por defecto): el paso 2 suma «¿Persona natural o
  empresa?» (radios nativos) y «Giro». Este archivo cambia la etiqueta y el texto de ayuda de «Razón social o nombre» según la
  elección, muestra «Giro» (obligatorio) solo para empresa y valida el grupo de radios. Sin esos campos no hace nada distinto.

  T-1552 (28-oct-2026, pedido de Benjamín Canales de Nibec):
    · Los PRODUCTOS son obligatorios. El producto ya no se pide escribiendo en el formulario: sin al menos un producto en la lista de cotización
      (nibec-cotizacion.js) «Continuar» y «Cotizar» no avanzan; se muestra un error con foco en el estado vacío (tarjeta «Tu cotización» de la columna
      derecha en computador, bloque `[data-nibec-productos-vacio]` dentro del formulario en celular y tablet). El texto de «Información adicional» es opcional.
    · Cómo necesita recibir los productos (radios, obligatorio) en el paso 2, con las cuatro opciones de Benjamín: «Necesito despacho Santiago», «Necesito armado
      Santiago», «Retiro en tienda» y «Despacho a Región». Solo con «Retiro en tienda» NO se piden dirección ni comuna: esos dos campos se ocultan y se
      deshabilitan (no se validan ni viajan en el correo). La elección sale en el correo como «Entrega: <opción>» y, como `entrega` = despacho_santiago |
      armado_santiago | retiro_tienda | despacho_region, en el campo oculto data-brevo="entrega" hacia el Worker de formularios (que la pasa a Versu; Brevo no la usa).
    · Mientras la lista está vacía, «Continuar» y «Cotizar» se ven apagados (clase is-sin-productos; NO están deshabilitados ni llevan aria-disabled: el lector de
      pantalla no los anuncia como no disponibles, reciben el foco y al apretarlos sale el error) y un aviso junto al botón dice por qué (aria-describedby).

  Sin JavaScript no pasa nada raro: se ven los dos bloques seguidos y el envío nativo valida con `required`.
*/
(function () {
  'use strict';

  var form = document.getElementById('contact_form');
  if (!form || form.getAttribute('data-nibec-formal') === 'listo') return;

  var p1 = form.querySelector('[data-paso="1"]');
  var p2 = form.querySelector('[data-paso="2"]');
  var siguiente = form.querySelector('[data-nibec-continuar]');
  var volver = form.querySelector('[data-nibec-volver]');
  var enviar = form.querySelector('button[type="submit"]');
  var rut = form.querySelector('[data-nibec-rut]');
  if (!p1 || !p2 || !siguiente || !volver || !enviar || !rut) return;

  form.setAttribute('data-nibec-formal', 'listo');
  form.classList.add('is-pasos');
  // Los mensajes los pone este archivo (con foco y aria-describedby); los globos del navegador no.
  form.noValidate = true;

  var actual = 1;
  var reducir = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var CORREO = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // el mismo que usa el Worker de Brevo

  // ---- RUT chileno -------------------------------------------------------------------------------------------
  function limpiarRut(v) {
    return String(v || '').replace(/[^0-9kK]/g, '').toUpperCase();
  }
  function digitoVerificador(cuerpo) {
    var suma = 0;
    var mult = 2;
    for (var i = cuerpo.length - 1; i >= 0; i--) {
      suma += parseInt(cuerpo.charAt(i), 10) * mult;
      mult = mult === 7 ? 2 : mult + 1;
    }
    var r = 11 - (suma % 11);
    return r === 11 ? '0' : r === 10 ? 'K' : String(r);
  }
  function rutValido(v) {
    var c = limpiarRut(v);
    if (c.length < 8 || c.length > 9) return false; // 7 u 8 dígitos y el verificador
    var cuerpo = c.slice(0, -1);
    // desde 1.000.000: deja fuera 0-0, 1-9 y otros inventados que también cumplen el módulo 11
    return /^[0-9]+$/.test(cuerpo) && parseInt(cuerpo, 10) >= 1000000 && digitoVerificador(cuerpo) === c.slice(-1);
  }
  function formatearRut(v) {
    var c = limpiarRut(v);
    if (c.length < 2) return c;
    return c.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + c.slice(-1);
  }

  // ---- Errores ----------------------------------------------------------------------------------------------
  // Los campos que se validan: sin los deshabilitados (p. ej. «Giro» de una persona natural) y con un solo radio por grupo.
  function campos(paso) {
    var vistos = {};
    return Array.prototype.slice
      .call(paso.querySelectorAll('input:not([type="hidden"]), textarea'))
      .filter(function (c) {
        if (c.disabled) return false;
        if (c.type === 'radio') {
          if (vistos[c.name]) return false;
          vistos[c.name] = true;
        }
        return true;
      });
  }
  // El error de un grupo de radios cuelga del grupo (fieldset), no de un radio suelto.
  function anfitrion(campo) {
    return (campo.type === 'radio' && campo.closest && campo.closest('[data-nibec-tipo], [data-nibec-entrega]')) || campo;
  }
  function limpiarError(campo) {
    var h = anfitrion(campo);
    h.removeAttribute('aria-invalid');
    var id = h.id + '-error';
    var previo = document.getElementById(id);
    if (previo && previo.parentNode) previo.parentNode.removeChild(previo);
    var resto = (h.getAttribute('aria-describedby') || '')
      .split(' ')
      .filter(function (x) { return x && x !== id; })
      .join(' ');
    if (resto) h.setAttribute('aria-describedby', resto);
    else h.removeAttribute('aria-describedby');
  }
  function ponerError(campo, texto, anunciar) {
    var h = anfitrion(campo);
    limpiarError(campo);
    var e = document.createElement('p');
    e.className = 'nibec-contacto__error';
    e.id = h.id + '-error';
    // T-0953 (diseño elevado): el error de la validación en línea se anuncia (el foco ya se fue a otro campo); los de «Continuar»/«Cotizar» no, porque el foco va al primer campo con error.
    if (anunciar) e.setAttribute('role', 'alert');
    e.textContent = texto;
    (h === campo ? campo.parentNode : h).appendChild(e);
    h.setAttribute('aria-invalid', 'true');
    h.setAttribute('aria-describedby', ((h.getAttribute('aria-describedby') || '') + ' ' + e.id).trim());
  }
  // Con productos en la lista de cotización (nibec-cotizacion.js) el producto viaja en un campo oculto: es lo que llega en el correo, así que es la
  // fuente de verdad de «hay productos». T-1552: son obligatorios; sin ese campo con valor no se continúa ni se envía.
  function hayLista() {
    var h = form.querySelector('input[name="contact[Productos a cotizar]"]');
    return !!(h && h.value.trim());
  }

  // ---- Productos obligatorios: estado vacío y error (T-1552) -------------------------------------------------
  // Hay dos bloques con el mismo papel (la tarjeta de la columna derecha, que solo se dibuja desde 990 px, y el bloque dentro del formulario para el resto
  // de los anchos). El error va en los dos; el que no se dibuja no se anuncia (display: none). El error NO lleva role="alert": el foco va a él y el lector
  // de pantalla lo lee al llegar (misma regla que los errores de «Continuar» y «Cotizar»).
  var vacios = document.querySelectorAll('[data-nibec-productos-vacio]');
  var ERROR_PRODUCTOS = 'Agrega al menos un producto para continuar.';
  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }
  function quitarErrorProductos() {
    Array.prototype.forEach.call(vacios, function (b) {
      var e = b.querySelector('.nibec-contacto__error--productos');
      if (e && e.parentNode) e.parentNode.removeChild(e);
      b.removeAttribute('data-invalido');
    });
  }
  function ponerErrorProductos() {
    var primero = null;
    Array.prototype.forEach.call(vacios, function (b, i) {
      var previo = b.querySelector('.nibec-contacto__error--productos');
      if (previo && previo.parentNode) previo.parentNode.removeChild(previo);
      var e = document.createElement('p');
      e.className = 'nibec-contacto__error nibec-contacto__error--productos';
      e.id = 'Nibec-productos-error-' + i;
      e.tabIndex = -1;
      e.textContent = b.getAttribute('data-nibec-productos-error') || ERROR_PRODUCTOS;
      var texto = b.querySelector('.nibec-contacto__vacio-txt, .nibec-contacto__faltan-txt');
      if (texto && texto.parentNode === b) b.insertBefore(e, texto.nextSibling);
      else b.appendChild(e);
      b.setAttribute('data-invalido', 'true');
      if (!primero && visible(e)) primero = e;
    });
    return primero;
  }
  // Muestra u oculta los bloques según haya o no productos (y limpia el error si ya hay). Con la lista vacía los botones «Continuar» y «Cotizar» se ven
  // apagados (clase is-sin-productos) y apuntan al aviso con aria-describedby: no son disabled ni aria-disabled, así que siguen recibiendo el foco y el clic muestra el error.
  var avisoProductos = form.querySelector('[data-nibec-productos-aviso]');
  function pintarVacios() {
    var hay = hayLista();
    Array.prototype.forEach.call(vacios, function (b) { b.hidden = hay; });
    if (hay) quitarErrorProductos();
    [siguiente, enviar].forEach(function (b) {
      if (!b) return;
      b.classList.toggle('is-sin-productos', !hay);
      if (hay) {
        if (avisoProductos && b.getAttribute('aria-describedby') === avisoProductos.id) b.removeAttribute('aria-describedby');
      } else {
        if (avisoProductos && !b.hasAttribute('aria-describedby')) b.setAttribute('aria-describedby', avisoProductos.id);
      }
    });
    if (avisoProductos) avisoProductos.hidden = hay;
  }
  function enfocarProductos(e) {
    if (!e) return;
    try { e.focus({ preventScroll: true }); } catch (x) { e.focus(); }
    // Se lleva a la vista el bloque entero (error y botón al catálogo), no solo el error: en celular el bloque queda entre los campos y la barra fija del botón.
    // Si no cabe completo, manda que se vea el error con el encabezado fijo arriba.
    var bloque = e.closest('[data-nibec-productos-vacio]') || e;
    var arriba = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ne-hdr'), 10) || 0) + 8;
    var barra = [siguiente, enviar].some(function (b) { return visible(b) && getComputedStyle(b).position === 'sticky'; });
    var abajo = window.innerHeight - (barra ? 96 : 12);
    var caja = bloque.getBoundingClientRect();
    var delta = 0;
    if (caja.bottom > abajo) delta = caja.bottom - abajo;
    if (caja.top - delta < arriba) delta = Math.max(0, caja.top - arriba);
    if (caja.top < arriba) delta = caja.top - arriba;
    if (delta) window.scrollBy({ top: delta, left: 0, behavior: reducir ? 'auto' : 'smooth' });
  }
  // nibec-cotizacion.js arma la lista (y el campo oculto) después de este archivo: se lee cuando todo cargó y cada vez que la lista cambia.
  // El evento sale antes de que el panel actualice el campo oculto, por eso se espera un instante.
  document.addEventListener('DOMContentLoaded', pintarVacios);
  window.addEventListener('load', pintarVacios);
  document.addEventListener('nibec:lista', function () { window.setTimeout(pintarVacios, 0); });
  window.addEventListener('storage', function () { window.setTimeout(pintarVacios, 0); });
  window.setTimeout(pintarVacios, 0);
  function problema(campo) {
    if (campo.type === 'radio') {
      var grupo = form.querySelectorAll('input[type="radio"]');
      var hay = false;
      for (var i = 0; i < grupo.length; i++) {
        if (grupo[i].name === campo.name && grupo[i].checked) hay = true;
      }
      return hay ? '' : anfitrion(campo).getAttribute('data-nibec-error') || 'Elige una opción.';
    }
    var v = campo.value.trim();
    var vacio = v === '';
    var texto = campo.getAttribute('data-nibec-error') || 'Completa este dato.';
    if (campo.required && vacio) return texto;
    if (campo === rut && !rutValido(v)) {
      return 'Revisa el RUT: escríbelo con su dígito verificador, por ejemplo 12.345.678-5.';
    }
    if (campo.type === 'email' && !vacio && !CORREO.test(v)) {
      return 'Revisa el correo: debe verse como nombre@empresa.cl.';
    }
    // T-0953 (diseño elevado): el teléfono solo se frena si es evidentemente corto (8 dígitos o más pasa; acepta +56, espacios y guiones).
    if (campo.type === 'tel' && !vacio && v.replace(/\D/g, '').length < 8) {
      return 'Revisa el teléfono: escríbelo con código de área o de celular, por ejemplo +56 9 1234 5678.';
    }
    return '';
  }
  // Marca todos los campos con problema del paso y devuelve el primero (o null).
  function validarPaso(paso) {
    var primero = null;
    campos(paso).forEach(function (campo) {
      var texto = problema(campo);
      if (texto) {
        ponerError(campo, texto);
        if (!primero) primero = campo;
      } else {
        limpiarError(campo);
      }
    });
    return primero;
  }

  // ---- Pasos ------------------------------------------------------------------------------------------------
  function medir(accion) {
    var datos = {
      paso: accion === 'volver' ? 1 : 2,
      accion: accion,
      dispositivo: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador'
    };
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('nibec_cotizacion_paso', datos);
    } catch (e) {}
    try {
      (window.dataLayer = window.dataLayer || []).push({ event: 'nibec_cotizacion_paso', paso: datos.paso, accion: accion, dispositivo: datos.dispositivo });
    } catch (e) {}
  }

  function mostrar(n, enfocar) {
    actual = n;
    p1.hidden = n !== 1;
    p2.hidden = n !== 2;
    siguiente.hidden = n !== 1;
    volver.hidden = n !== 2;
    enviar.hidden = n !== 2;
    var paso = n === 1 ? p1 : p2;
    if (!reducir) {
      paso.classList.remove('is-entrando');
      void paso.offsetWidth;
      paso.classList.add('is-entrando');
    }
    if (enfocar) {
      var titulo = paso.querySelector('.nibec-contacto__paso-tit');
      if (titulo) {
        try { titulo.focus({ preventScroll: true }); } catch (e) { titulo.focus(); }
        // se lleva a la vista el bloque entero (con «Volver» y «Paso N de 2»), no solo el título. T-0953 (diseño elevado): solo si no se ve ya
        // (con el formulario completo en la primera pantalla la página no debe moverse al cambiar de paso).
        var caja = paso.getBoundingClientRect();
        var arriba = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ne-hdr'), 10) || 0;
        if (caja.top < arriba || caja.top > window.innerHeight * 0.55) {
          paso.scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'start' });
        }
      }
    }
  }

  function irAlPaso2() {
    var malo = validarPaso(p1);
    // T-1552: sin productos no se continúa. El error de productos se muestra junto a los de los campos; el foco va al primer campo con error y, si
    // los campos están bien, al error de productos.
    var sinProductos = !hayLista();
    var errorProductos = null;
    if (sinProductos) errorProductos = ponerErrorProductos();
    else quitarErrorProductos();
    if (malo) {
      malo.focus();
      return;
    }
    if (sinProductos) {
      enfocarProductos(errorProductos);
      return;
    }
    mostrar(2, true);
    medir('continuar');
  }

  siguiente.addEventListener('click', irAlPaso2);
  volver.addEventListener('click', function () {
    mostrar(1, true);
    medir('volver');
  });

  // El error se va apenas la persona corrige el campo.
  form.addEventListener('input', function (e) {
    var c = e.target;
    if (c && c.getAttribute && anfitrion(c).getAttribute('aria-invalid') === 'true') limpiarError(c);
    if (c && c.classList) c.classList.remove('is-ok');
  });
  // T-0953 (diseño elevado, CW-LEAD-1): validación en línea. Al SALIR de un campo con algo escrito se avisa si está mal (mensaje en el campo, con
  // salida) o se marca con un visto verde; un campo vacío no se castiga hasta «Continuar» o «Cotizar» (premiar pronto, avisar tarde).
  form.addEventListener('focusout', function (e) {
    var c = e.target;
    if (!c || !c.matches || !c.matches('input:not([type="hidden"]):not([type="radio"]), textarea')) return;
    if (c.disabled || !c.value.trim()) { c.classList.remove('is-ok'); return; }
    var texto = problema(c);
    if (texto) { c.classList.remove('is-ok'); ponerError(c, texto, true); }
    else { limpiarError(c); if (c.tagName !== 'TEXTAREA') c.classList.add('is-ok'); }
  });
  // ---- «¿Persona natural o empresa?» (solo si el ajuste está encendido) --------------------------------------
  var tipo = form.querySelector('[data-nibec-tipo]');
  if (tipo) {
    var razon = form.querySelector('[data-nibec-razon]');
    var razonEtiqueta = form.querySelector('[data-nibec-razon-label]');
    var giroBloque = form.querySelector('[data-nibec-giro]');
    var giro = giroBloque && giroBloque.querySelector('input');
    var POR_TIPO = {
      'Persona natural': { etiqueta: 'Nombre completo', ayuda: 'Tu nombre y apellido', auto: 'name', giro: false },
      Empresa: { etiqueta: 'Razón social', ayuda: 'Razón social de tu empresa', auto: 'organization', giro: true }
    };
    var aplicarTipo = function () {
      var marcado = tipo.querySelector('input[type="radio"]:checked');
      var t = marcado && POR_TIPO[marcado.value];
      if (!t || !razon || !razonEtiqueta || !giro || !giroBloque) return;
      razonEtiqueta.textContent = t.etiqueta;
      razon.placeholder = t.ayuda;
      razon.setAttribute('autocomplete', t.auto);
      giroBloque.hidden = !t.giro;
      giro.disabled = !t.giro;
      giro.required = t.giro;
      if (!t.giro) limpiarError(giro);
    };
    tipo.addEventListener('change', aplicarTipo);
    aplicarTipo(); // el navegador puede devolver la página con una opción ya marcada
  }
  // ---- Entrega (T-1552) ---------------------------------------------------------------------------------------
  // Cuatro opciones (data-entrega): despacho_santiago, armado_santiago, retiro_tienda y despacho_region. Sin elección no se muestran dirección ni comuna; con
  // cualquier opción menos «Retiro en tienda» se piden; con «Retiro en tienda» quedan ocultos y deshabilitados (un campo deshabilitado no se valida ni viaja en
  // el correo). Lo escrito se conserva si la persona cambia de opinión. La nota bajo las opciones (data-nota de cada radio) es una región en vivo.
  var entrega = form.querySelector('[data-nibec-entrega]');
  var entregaCampos = form.querySelector('[data-nibec-entrega-campos]');
  var entregaNota = form.querySelector('[data-nibec-entrega-nota]');
  var entregaCopia = form.querySelector('[data-nibec-brevo-entrega]');
  var ENTREGAS = { despacho_santiago: 1, armado_santiago: 1, retiro_tienda: 1, despacho_region: 1 };
  function entregaMarcada() {
    return entrega && entrega.querySelector('input[type="radio"]:checked');
  }
  function entregaElegida() {
    var marcado = entregaMarcada();
    var v = marcado ? marcado.getAttribute('data-entrega') : '';
    return ENTREGAS[v] ? v : '';
  }
  function aplicarEntrega() {
    if (!entrega) return;
    var v = entregaElegida();
    var marcado = entregaMarcada();
    if (entregaCopia) entregaCopia.value = v;
    if (entregaNota) entregaNota.textContent = (marcado && marcado.getAttribute('data-nota')) || '';
    if (!entregaCampos) return;
    var pedir = v !== '' && v !== 'retiro_tienda';
    entregaCampos.hidden = !pedir;
    Array.prototype.forEach.call(entregaCampos.querySelectorAll('input'), function (c) {
      c.disabled = !pedir;
      if (!pedir) limpiarError(c);
    });
  }
  if (entrega) {
    entrega.addEventListener('change', aplicarEntrega);
    aplicarEntrega(); // el navegador puede devolver la página con una opción ya marcada
  }

  // El RUT queda escrito como 12.345.678-5 al salir del campo.
  rut.addEventListener('blur', function () {
    if (rut.value.trim()) rut.value = formatearRut(rut.value);
  });

  // T-0953 (diseño elevado): al enviar de verdad, el botón muestra que está trabajando (giro + «Enviando tu cotización…») y un aviso para el lector de
  // pantalla. Si la página no cambia (p. ej. se cierra el desafío del captcha), a los 25 s el botón vuelve a su estado y se puede reintentar.
  var textoEnviar = '';
  var estadoEnviar = null;
  function marcarEnviando() {
    if (enviar.classList.contains('is-enviando')) return;
    textoEnviar = enviar.textContent.replace(/\s+/g, ' ').trim();
    enviar.classList.add('is-enviando');
    enviar.setAttribute('aria-busy', 'true');
    enviar.textContent = '';
    var giro = document.createElement('span');
    giro.className = 'ne-giro';
    giro.setAttribute('aria-hidden', 'true');
    var t = document.createElement('span');
    t.textContent = 'Enviando tu cotización…';
    enviar.appendChild(giro);
    enviar.appendChild(t);
    if (!estadoEnviar) {
      estadoEnviar = document.createElement('p');
      estadoEnviar.className = 'visually-hidden';
      estadoEnviar.setAttribute('role', 'status');
      form.appendChild(estadoEnviar);
    }
    estadoEnviar.textContent = 'Enviando tu cotización.';
    window.setTimeout(function () {
      if (!enviar.classList.contains('is-enviando')) return;
      enviar.classList.remove('is-enviando');
      enviar.removeAttribute('aria-busy');
      enviar.textContent = textoEnviar;
      if (estadoEnviar) estadoEnviar.textContent = '';
    }, 25000);
  }

  // Va en la fase de captura de window, antes que cualquier otro listener: Shopify pone en el formulario un listener de
  // hCaptcha que hace preventDefault, corre el desafío y envía después con el submit nativo (sin validar nada). Si
  // este bloqueo corriera después, el desafío arrancaría igual y el formulario saldría incompleto. Con
  // stopImmediatePropagation el envío bloqueado no llega ni al captcha ni a nibec-brevo.js (la copia para Brevo solo
  // se guarda cuando el envío es de verdad).
  window.addEventListener(
    'submit',
    function (e) {
      if (e.target !== form) return;
      if (actual === 1) {
        // Enter dentro del paso 1: es «Continuar», no un envío.
        e.preventDefault();
        e.stopImmediatePropagation();
        irAlPaso2();
        return;
      }
      var malo1 = validarPaso(p1);
      var malo2 = validarPaso(p2);
      // T-1552: la lista se puede vaciar desde la columna derecha estando en el paso 2; sin productos tampoco se envía.
      var sinProductos = !hayLista();
      var errorProductos = null;
      if (sinProductos) errorProductos = ponerErrorProductos();
      else quitarErrorProductos();
      if (malo1 || malo2 || sinProductos) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (malo1) {
          mostrar(1, false);
          malo1.focus();
        } else if (malo2) {
          malo2.focus();
        } else {
          enfocarProductos(errorProductos);
        }
        return;
      }
      rut.value = formatearRut(rut.value);
      aplicarEntrega();
      var direccion = form.querySelector('[data-nibec-direccion]');
      var comuna = form.querySelector('[data-nibec-comuna]');
      var copia = form.querySelector('[data-nibec-brevo-direccion]');
      if (copia) {
        // Con «Retiro en tienda» no hay dirección ni comuna (los campos están deshabilitados y no viajan): la copia para Brevo y el Worker queda vacía.
        var conDireccion = !entrega || entregaElegida() !== 'retiro_tienda';
        copia.value = conDireccion ? [direccion && direccion.value.trim(), comuna && comuna.value.trim()].filter(Boolean).join(', ') : '';
      }
      medir('enviar');
      marcarEnviando();
    },
    true
  );

  mostrar(1, false);
})();
